export const filterNullableValues = (obj) => {
    if (!obj) return {};

    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (!value) return acc;

        if (
            typeof value === "object" &&
            !Array.isArray(value) &&
            value !== null
        ) {
            acc = { ...acc, [key]: filterNullableValues(value) };

            return acc;
        }

        acc[key] = value;

        return acc;
    }, {});
}
